'use strict'

class Wpml {

	constructor() {
	  this.languageSwitcher = document.querySelector('[data-wpml-ls]');
	}

	setCookie(name, value, expiresInDays) { // FIXME make globally accessible
		const d = new Date();
		d.setTime(d.getTime() + (expiresInDays*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = name + "=" + value + ";" + expires + ";path=/";
	}

	init() {

	  if(!this.languageSwitcher) return false;

	  this.languageSwitcher.addEventListener('click', (el) => {
		el.preventDefault();
		const preferredLanguage = el.currentTarget.dataset.wpmlLs;
		this.setCookie('manual_lang', preferredLanguage, 365);
		window.location.href = this.languageSwitcher.href;
		return false;
	  });

	}
}
